module.exports = __webpack_public_path__ + "static/media/icon_distribution.baa5a007.svg";